const apiBaseUrl =
  process.env.REACT_APP_Environment === "development"
    ? process.env.REACT_APP_API_URL
    : process.env.REACT_APP_API_URL_Production;

// Rider documents + remittance proofs are stored on MobileAPI only.
const mobileApiBaseUrl =
  process.env.REACT_APP_Environment === "development"
    ? process.env.REACT_APP_MOBILE_API_URL
    : process.env.REACT_APP_MOBILE_API_URL_Production;

export const toImageUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("http")) return path;
  const base = (mobileApiBaseUrl || apiBaseUrl || "")
    .replace(/\/api\/?$/, "")
    .replace(/\/$/, "");
  return `${base}/${path.replace(/\\/g, "/").replace(/^\//, "")}`;
};

export const toRelativePath = (path) => {
  if (!path) return "";
  if (!path.startsWith("http")) return path.replace(/\\/g, "/");
  try {
    const url = new URL(path);
    return url.pathname.replace(/^\//, "");
  } catch {
    return path;
  }
};

export const defaultRiderForm = {
  marketplaceRider_ID: 0,
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  password: "",
  profileImagePath: "",
  cnicNumber: "",
  cnicFrontImagePath: "",
  cnicBackImagePath: "",
  vehicleType: "",
  vehicleNumber: "",
  employmentType: "Freelancer",
  hoursShift: 8,
  perOrderCommission: 0,
  salary: 0,
  starLevel: 1,
  vehicleCopyImagePath: "",
  drivingLicenseImagePath: "",
  serviceCountryCode: "PAK",
  serviceCity: "",
  residenceZoneId: null,
  maxRadiusKm: 10,
  approvalStatus: "Approved",
  isOnline: false,
};

export const mapRiderToForm = (rider) => {
  if (!rider) return { ...defaultRiderForm };
  const country = rider.serviceCountryCode || rider.ServiceCountryCode || "PAK";
  const city = rider.serviceCity || "";
  const residenceZoneId =
    rider.residenceZoneId ||
    rider.ResidenceZoneId ||
    (Array.isArray(rider.zoneIds) && rider.zoneIds.length > 0 ? rider.zoneIds[0] : null) ||
    (Array.isArray(rider.zones) && rider.zones.length > 0
      ? rider.zones[0].zoneId || rider.zones[0].Zone_ID
      : null) ||
    null;

  return {
    marketplaceRider_ID: rider.marketplaceRiderId || rider.marketplaceRider_ID || 0,
    firstName: rider.firstName || "",
    lastName: rider.lastName || "",
    email: rider.email || "",
    phone: rider.phone || "",
    password: "",
    profileImagePath: toRelativePath(rider.profileImagePath || ""),
    cnicNumber: rider.cnicNumber || "",
    cnicFrontImagePath: toRelativePath(rider.cnicFrontImagePath || ""),
    cnicBackImagePath: toRelativePath(rider.cnicBackImagePath || ""),
    vehicleType: rider.vehicleType || "",
    vehicleNumber: rider.vehicleNumber || "",
    employmentType: rider.employmentType || "Freelancer",
    hoursShift: rider.hoursShift || 8,
    perOrderCommission: rider.perOrderCommission ?? 0,
    salary: rider.salary ?? 0,
    starLevel: rider.starLevel || 1,
    vehicleCopyImagePath: toRelativePath(rider.vehicleCopyImagePath || ""),
    drivingLicenseImagePath: toRelativePath(rider.drivingLicenseImagePath || ""),
    serviceCountryCode: country,
    serviceCity: city,
    residenceZoneId: residenceZoneId || null,
    maxRadiusKm: rider.maxRadiusKm ?? 10,
    approvalStatus: rider.approvalStatus || "Approved",
    isOnline: !!rider.isOnline,
  };
};

export const buildRiderUpsertPayload = (form, selectedResidenceZone) => ({
  marketplaceRider_ID: form.marketplaceRider_ID,
  firstName: form.firstName.trim(),
  lastName: form.lastName.trim(),
  email: form.email.trim(),
  phone: form.phone.trim(),
  password: form.password.trim() || undefined,
  profileImagePath: form.profileImagePath.trim() || null,
  cnicNumber: form.cnicNumber.trim() || null,
  cnicFrontImagePath: form.cnicFrontImagePath.trim() || null,
  cnicBackImagePath: form.cnicBackImagePath.trim() || null,
  vehicleType: form.vehicleType.trim() || null,
  vehicleNumber: form.vehicleNumber.trim() || null,
  employmentType: form.employmentType || "Freelancer",
  hoursShift: Number(form.hoursShift) || 8,
  perOrderCommission: Number(form.perOrderCommission) || 0,
  salary: Number(form.salary) || 0,
  starLevel: Number(form.starLevel) || 1,
  vehicleCopyImagePath: form.vehicleCopyImagePath.trim() || null,
  drivingLicenseImagePath: form.drivingLicenseImagePath.trim() || null,
  serviceCountryCode: (form.serviceCountryCode || "PAK").trim().toUpperCase(),
  serviceCity: form.serviceCity.trim(),
  residenceZoneId: selectedResidenceZone?.value || form.residenceZoneId || null,
  maxRadiusKm: Number(form.maxRadiusKm) || 10,
  approvalStatus: form.approvalStatus,
  isOnline: form.isOnline,
});
